import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Icon from '@/components/Icon';
import Notice from '@/components/Notice';
import styles from '../index.less';
import placeholderImg from '@/assets/imgs/placeholderimg.png';
import {TLang, ReplaceText} from '@/utils/lang';
const MovieInfo = (props) => {
  // 控制 电影详情 的按钮状态
  const [showToggleBtn, setShowToggleBtn] = useState(false);
  // 电影详情 flag
  const [descFlag, setDescFlag] = useState(false);

  const { movie, defaultShowAll = false } = props;
  if (!movie || !movie?.id) {
    return <div className={styles.movieInfo}>
      {TLang('影片信息加载中', 'home', false, false, null)}</div>;
  }

  useEffect(() => {
    try {
      renderBg();
    } catch (e) {
      console.error('加载影片信息异常', e);
    }
  }, [movie]);

  const renderBg = (i = 0) => {
    if (movie && window) {
      const descDom: any = document.querySelector('.descText');
      // 最多重试5次
      if (!descDom && i < 6) {
        const c = i + 1;
        renderBg(c);
        return;
      }

      const domHeight = descDom?.offsetHeight || 0;
      if (!domHeight) {
        return;
      }
      var style = window?.getComputedStyle(descDom, null);
      var lineHeight = parseInt(style.lineHeight === 'normal' ? style.fontSize : style.lineHeight);
      if (domHeight > lineHeight * 3) { // 3 表示 三行，大于三行就显示 更多 按钮
        setShowToggleBtn(true);
      }
      // const bgimg = movie?.logo || placeholderImg;
      // set bg image
      // if (document?.styleSheets.length > 0) {
      //   document?.styleSheets[0].addRule('.bgimage::before', 'background: url("' + bgimg + '")');
      // }
    }
  };

  const toggleShowDesc = () => {
    setDescFlag(!descFlag);
  };

  return <div className={`${styles.mDetailContainer} movieDetail`}>
    <div className={styles.container}>
      <div className={`${styles.bgImg} bgimage`} style={{ backgroundImage: `url(${movie.logo})` }} data-bgimg={movie.logo ? movie.logo : placeholderImg}>
        <div className={styles.mask} />
      </div>
      {
        movie.alert ?
          <div className={styles.noticeWrapper}>
            <Notice bgColor="rgba(0,0,0,0.4)" textColor="#FFFFFF" text={movie.alert} />
          </div> : null
      }
      <div className={`${styles.filmWrapper} ${!movie.alert ? styles.noNotice : ''}`}>

        <div className={styles.filmMainInfo}>
          <div className={`${styles.img} ${movie.logo ? '' : 'logo'}`}>
            <img src={movie.logo} alt="" />
          </div>

          <div className={styles.infoWrapper}>
            <div className={`${styles.textline} ${styles.textTitle}`}>{movie.name}</div>
            <div className={styles.textline}>
              <span>{TLang('导演', 'home', false, false, null)}:&nbsp;</span>
              <p className={styles.textlineContent}>
                {movie?.director}
              </p>
            </div>
            <div className={`${styles.textline} ${styles.wrap2}`}>
              <span>{TLang('主演', 'home', false, false, null)}:&nbsp;</span>
              <p className={styles.textlineContent}>
                {
                  movie?.actor
                }
              </p>
            </div>
            <div className={`${styles.textline} ${styles.sm}`}>
              <span>{TLang('类型', 'home', false, false, null)}:&nbsp;</span>
              <p>{movie?.types && movie?.types.length > 0 && movie.types.join(' ')}</p>
            </div>
            <div className={`${styles.textline} ${styles.sm}`}>
              <span>{TLang('片长', 'home', false, false, null)}:&nbsp;</span>
              <p>{movie?.duration}{TLang('分钟', 'home', false, false, null)}</p>
            </div>
          </div>
        </div>
        <div className={styles.filmDescWrapper}>
          <p className={`${styles.filmDesc} ${!defaultShowAll && descFlag === false ? styles.elli : ''}`}>
            <span className={'descText'}>{movie.desc}</span>
          </p>
          {
            !defaultShowAll && showToggleBtn ? <div className={`${styles.showBtn} ${!defaultShowAll &&descFlag === false ? styles.elli : ''}`} onClick={toggleShowDesc}>
              <div className={styles.rotateDown}>
                <Icon key="1"
                  type="order_selectdate_more"
                  size="xxs"
                  style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#B2B2B2' }}
                />
              </div>
            </div> : null
          }
        </div>
      </div>
    </div>
  </div>;
};
export default MovieInfo;

